import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import React, { FC, useEffect, useState } from 'react';
import { Button, Grid, Segment } from '../../kit';
import Timeline from '../../modules/Timeline';
import { ssoUrl, useProfile } from '../../lib/auth';
import styles from './styles.module.scss';
import Avatar from '../../components/Avatar';
import { CoachApi } from '../../models/Coach';
import { ApiProfile } from '../../api/auth';
import { request } from '../../api';
import { showFullscreenMessage } from '../../components/FullscreenMessage';

const CommunityView: FC = (): JSX.Element => {
    const [ events, setEvents ] = useState<any[]>();
    const [ exercise, setExercise ] = useState<any>();
    const [ knowledge, setKnowledge ] = useState<any>();
    const [ profiles, setProfiles ] = useState<ApiProfile[]>([]);
    const auth = useProfile();

    const fetchProfiles = (): void => {
        CoachApi.listNew().then(({ data }) => {
            setProfiles(data.data);
        });
    }

    const fetchDashboard = (): void => {
        request.get('dashboard').then(({ data }) => {
            setEvents(data.events);
            setExercise(data.exercise);
            setKnowledge(data.knowledge);
        });
    }

    useEffect(() => {
        fetchProfiles();
        fetchDashboard();
    }, []);

    const subscribe = (event: any): void => {
        request.post(`events/${event.id}/subscribe`).then(({ data }) => {
            fetchDashboard();
            showFullscreenMessage(`Je hebt je ${data.copy}!`);
        });
    }

    return (
        <div className="container" style={{ maxWidth: 1140 }}>
            <Grid.Row>
                <Grid.Column lg={3}>
                    <div className="small-people">
                        <div className="person" style={{ margin: '0 0 32px 0' }}>
                            <div
                                className="person__avatar person__avatar--square"
                                style={{ backgroundImage: `url(${auth?.avatar || `${process.env.REACT_APP_WP_URL}assets/images/placeholder.jpg`}` }}
                            >
                                <div className="person__trophies">
                                    {(auth?.academy_offline || auth?.academy_online) && (
                                        <span className="grad"><i className="far fa-graduation-cap" /></span>
                                    )}
                                    {auth?.subscription === 'full' && (
                                        <span><i className="far fa-star" /></span>
                                    )}
                                </div>
                            </div>
                            <div className="person__meta">
                                <h3 style={{ margin: 0 }}>{auth?.name}</h3>
                                <p style={{ margin: 0, fontSize: 14 }}>{auth?.organisation}</p>
                            </div>
                            <a href={`/community/${auth?.permalink}`}>
                                Mijn profiel
                                <i className="fa-regular fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                    <h2>Ga direct naar</h2>
                    <div className={styles.buttons}>
                        <Button
                            color="white"
                            label="Tool"
                            href={ssoUrl('start')}
                            icon={faArrowRight}
                            iconPosition="right"
                            target="_blank"
                        />
                        <Button
                            color="white"
                            label="Oefeningen"
                            href={ssoUrl('exercises')}
                            icon={faArrowRight}
                            iconPosition="right"
                            target="_blank"
                        />
                        <Button
                            color="white"
                            label="Kennisbank"
                            href={ssoUrl('kb')}
                            icon={faArrowRight}
                            iconPosition="right"
                            target="_blank"
                        />
                        <Button
                            color="white"
                            label="Academy"
                            href="https://www.spatverandert.nl/academy"
                            icon={faArrowRight}
                            iconPosition="right"
                            target="_blank"
                        />
                        <Button
                            color="white"
                            label="Boek"
                            href="/product/intelligent-bewegen/"
                            icon={faArrowRight}
                            iconPosition="right"
                        />
                    </div>
                    <div className={styles.hideMobile}>
                        {exercise && (<>
                            <h2 style={{ marginTop: 32 }}>Nieuwste oefening</h2>
                            <Segment
                                className={styles.exercise}
                            >
                                <h3 style={{ marginBottom: 16 }}>{exercise.name}</h3>
                                <a
                                    className={styles.exerciseProfile}
                                    href={`/community/${exercise.profile.permalink}`}
                                >
                                    <Avatar profile={exercise.profile} size={32} />
                                    {exercise.profile.name}
                                </a>
                            </Segment>
                            <div className={styles.button}>
                                <Button
                                    color="transparent"
                                    icon={faArrowRight}
                                    iconPosition="right"
                                    href={ssoUrl(`exercises/${exercise.id}`)}
                                    label="Bekijk oefening"
                                />
                            </div>
                        </>)}
                        {knowledge && (<>
                            <h2 style={{ marginTop: 32 }}>Kennisbank</h2>
                            <Segment
                                className={styles.exercise}
                            >
                                <h3 style={{ marginBottom: 16 }}>{knowledge.subject}</h3>
                                <a
                                    className={styles.exerciseProfile}
                                    href={`/community/${knowledge.profile.permalink}`}
                                >
                                    <Avatar profile={knowledge.profile} size={32} />
                                    {knowledge.profile.name}
                                </a>
                            </Segment>
                            <div className={styles.button}>
                                <Button
                                    color="transparent"
                                    icon={faArrowRight}
                                    iconPosition="right"
                                    href={ssoUrl(`kb/${knowledge.id}`)}
                                    label="Bekijk item"
                                />
                            </div>
                        </>)}
                    </div>
                </Grid.Column>
                <Grid.Column lg={6}>
                    {auth && (
                        <Timeline
                            auth={auth}
                        />
                    )}
                </Grid.Column>
                <Grid.Column lg={3}>
                    <h2>Evenementen</h2>
                    {events?.map((event) => (
                        <Segment
                            key={`event-${event.id}`}
                            className={styles.event}
                        >
                            <div>
                                <div className={styles.eventDate}>
                                    <span>{event.day}</span>
                                    {event.month}
                                </div>
                                <div className={styles.eventMeta}>
                                    <a href={`/community/event-${event.id}`}>{event.title}</a><br />
                                    {event.time}, {event.location}
                                </div>
                            </div>
                            <Button
                                color="white"
                                label={event.subscribed ? 'Je bent aangemeld' : 'Ik ben erbij!'}
                                onClick={() => subscribe(event)}
                            />
                        </Segment>
                    ))}

                    {profiles.length > 0 && (<>
                        <h2 style={{ marginTop: 32 }}>Welkom nieuwkomers</h2>
                        {profiles.map((profile) => (
                            <Segment
                                key={`profile-${profile.id}`}
                                className={styles.profile}
                                onClick={() => (window as any).location.href = `/community/${profile.permalink}`}
                            >
                                <Avatar profile={profile} />
                                <div className={styles.profileMeta}>
                                    <a href={`/community/${profile.permalink}`}>{profile.name}</a><br />
                                    {profile.organisation}
                                </div>
                                <i className="far fa-chevron-right" />
                            </Segment>
                        ))}
                    </>)}
                </Grid.Column>
            </Grid.Row>
        </div>
    );
}

export default CommunityView;
